import {makeAutoObservable} from 'mobx'
import services from "../services"
import {flatten, uniqBy} from "lodash";
import {extractErrorMessage} from "../utils/helpers";
import {generateLoadList} from "../utils/mobx";

class SalesAchieverAudiosStore {
    constructor(libraryStore) {
        makeAutoObservable(this)
        this.libraryStore = libraryStore
    }

    allTimesSeries = []
    seriesLoading = false
    mediaType = false

    error = null

    setError(error, type = "series") {
        error = extractErrorMessage(error)
        this.error = error
    }

    loadSeries = generateLoadList( "series", this, "seriesLoading"
        , async (lang)=>{
            if ( this.libraryStore.library.length ===0 )
                await this.libraryStore.loadLibrary();
            try {
                const IDS = { "en": "eAllTimeGreats", "fr": "eFRRoyalTop30" }
                if ( !IDS[lang] ) return
                return   services.Library.details(IDS[lang])
            }
            catch(e){
            }
        }, "allTimesSeries", "[0].files")



}

export default SalesAchieverAudiosStore